// extracted by mini-css-extract-plugin
export default {"main":"sca-z"};